<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="服务名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'name', validatorRules.name]" placeholder="请输入服务名称"></a-input>
        </a-form-item>
        <a-form-item label="所属服务器ip" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-search-select-tag
            v-decorator="[ 'serverId', validatorRules.serverId]"
            placeholder="所属服务器ip,下拉搜索"
            dict="bus_servermanage_servers,ip,id"
            :trigger-change="true"
            :async="true">
          </j-search-select-tag>
        </a-form-item>
        <a-form-item label="端口号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'port', validatorRules.port]" placeholder="请输入端口号"></a-input>
        </a-form-item>
        <a-form-item label="分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['type', validatorRules.type]" :trigger-change="true" dictCode="bus_server_service_type" placeholder="请选择分类"/>
        </a-form-item>
        <a-form-item label="文件位置" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'fileSrc', validatorRules.fileSrc]" placeholder="请输入文件位置"></a-input>
        </a-form-item>
        <a-form-item label="启动步骤" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-editor :key="editorKey" v-decorator="['startStep',{trigger:'input'}]"/>
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'sort', validatorRules.sort]" placeholder="请输入排序"></a-input>
        </a-form-item>
        <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch  v-decorator="[ 'izActivity', validatorRules.izActivity]"   checkedChildren="启用"   unCheckedChildren="禁用" ></a-switch>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"

  import JEditor from '@/components/jeecg/JEditor'

  export default {
    name: "BusServermanageServiceModal",
    components: { 
      JDictSelectTag,
      JEditor,
      JSearchSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          name: {rules: [
            { validator: (rule, value, callback) => validateDuplicateValue('bus_servermanage_service', 'name', value, this.model.id, callback)},
          ]},
          serverId: {rules: [
          ]},
          port: {rules: [
          ]},
          type: {rules: [
          ]},
          fileSrc: {rules: [
          ]},
          startStep: {rules: [
          ]},
          sort: {rules: [
          ]},
          izActivity: {rules: [
          ],valuePropName: 'checked'},
          remarks: {rules: [
          ],},
        },
        url: {
          add: "/servermanage/busServermanageService/add",
          edit: "/servermanage/busServermanageService/edit",
        },
        editorKey:new Date().valueOf()
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.visible = true;
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.model.izActivity=(record.izActivity===1)?true:false
        this.$nextTick(() => {
          this.editorKey=new Date().valueOf()
          this.form.setFieldsValue(pick(this.model,'name','serverId','port','type','fileSrc','startStep','sort','izActivity','delFlag'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            values.izActivity=values.izActivity?1:0;
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','serverId','port','type','fileSrc','startStep','sort','izActivity','delFlag'))
      },

      
    }
  }
</script>